import React from 'react';
import imgDesign from '../../static/images/imgDesign.jpg';
import imgTrends from '../../static/images/imgTrends.png';
import imgBranding from '../../static/images/imgBranding.jpg';
import imgMenus from '../../static/images/imgMenus.jpg';

const insights = [
    {
        image: imgDesign,
        label: 'Design',
        title: 'Key features for restaurant websites',
        text: 'Must-have tools and integrations for hospitality websites.',
    },
    {
        image: imgTrends,
        label: 'Trends',
        title: 'Top web trends for dining',
        text: 'Discover the latest design features shaping the hospitality industry.',
    },
    {
        image: imgBranding,
        label: 'Branding',
        title: 'Telling your brand’s story online',
        text: 'Tips for sharing your restaurant or bar’s story through design.',
    },
    {
        image: imgMenus,
        label: 'Menus',
        title: 'Menus that drive more orders',
        text: 'Designing digital menus that increase check size & reduce friction.',
    },
];

function InsightsSection() {
    return (
        <section className="insights-section py-5">
            <div className="container">
                <small className="text-uppercase eyebrow">Industry Insights</small>
                <h2 className="text-white mb-2">Real strategies that grow your business</h2>
                <p className="text-light mb-5">
                    Stay updated with practical tips, trends, and real-world examples for restaurant and bar websites.
                </p>

                <div className="row gy-4">
                    {insights.map((insight, idx) => (
                        <div className="col-md-6" key={idx}>
                            <div className="insight-card d-flex p-4">
                                <img src={insight.image} alt={insight.label} className="insight-icon" />
                                <div>
                                    <span className="section-label text-light fw-medium">{insight.label}</span>
                                    <h5 className="insight-card-header mb-1">{insight.title}</h5>
                                    <p className="text-light mb-0">{insight.text}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default InsightsSection;
